import React from 'react';
import { Spinner, Container } from './styled';

function Loader({ show }) {
  const height = typeof(window) !== 'undefined' ? window.innerHeight + 'px' : '100vh';
  return (
    <Container height={height} show={show}>
      <Spinner />
    </Container>
  );
}

export default Loader;